import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "supplier-comprehensive-order" }

import { ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseButton,
  XrkTableRef,
  XrkMessage
} from 'xrk-components';

import { comprehensivePageList } from '../data-source/apis';
import {
  indexCol,
  orderNoCol,
  refOrderNoCol,
  projectNameCol,
  customerNameCol,
  orderTimeCol,
  orderPayTimeCol,
  comprehensiveServiceAmountCol,
  payStatusCol,
  payPassagewayCol,
  payTypeCol
} from '../fields/columns';
import {
  orderNoSearch,
  refOrderNoSearch,
  projectNameSearch,
  customerNameSearch,
  orderTimeAtSearch,
  orderPayTimeAtSearch,
  payPassagewayNameSearch,
  supplierPayTypeSearch,
  payStatusSearch
} from '../fields/searchs';
import { ORDER_PAY_STATUS_PAY_SUCCESS } from '../constants';
import {
  batchDownLoadReceiptBySupplier,
  downLoadReceipt
} from '@/common/hooks/order/order-download';


export default /*#__PURE__*/_defineComponent({
  __name: 'supplier-comprehensive-order',
  setup(__props) {

const xrkTableRef = ref<XrkTableRef>();
const router = useRouter();
const route = useRoute();

const selectionVal = computed(() => {
  return xrkTableRef.value?.getSelectionRows();
});

// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置',
    beforeReset: () => {
      // 清除路由上的查询参数
      if (route.query.orderNo) {
        router.replace({
          query: { force: Date.now() }
        });
      }
    }
  },
  searchColumns: [
    { ...orderNoSearch, defaultValue: route.query.orderNo },
    refOrderNoSearch,
    projectNameSearch,
    customerNameSearch,
    orderTimeAtSearch,
    orderPayTimeAtSearch,
    payPassagewayNameSearch,
    supplierPayTypeSearch,
    {
      ...payStatusSearch,
      config: {
        options: ORDER_PAY_STATUS_PAY_SUCCESS
      }
    }
  ],
  otherComponents: [
    {
      render() {
        return (
          <>
            <BaseButton
              v-resource={[['下载回单']]}
              type="primary2"
              onClick={async () => {
                if (!selectionVal.value.length) {
                  XrkMessage.error('请选择一条数据');
                  return;
                }
                //批量下载回单

                await batchDownLoadReceiptBySupplier({
                  downloadType: 703,
                  downloadList: selectionVal.value.map(item => {
                    return {
                      id: item.id,
                      supplierOrderId: item.id,
                      orderType: item.orderType
                    };
                  })
                });
              }}
            >
              批量下载回单
            </BaseButton>
          </>
        );
      }
    }
  ]
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: '_selection',
      prop: 'id',
      align: 'center',
      fixed: 'left',
      width: 120
    }),
    indexCol,
    orderNoCol,
    refOrderNoCol,
    projectNameCol,
    customerNameCol,
    orderTimeCol,
    orderPayTimeCol,
    comprehensiveServiceAmountCol,
    {
      ...payStatusCol,
      formatter({ cellValue }) {
        return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
      }
    },
    payPassagewayCol,
    payTypeCol,
    useTableColumn({
      align: 'center',
      fixed: 'right',
      label: '操作',
      width: 230,
      render({ row }) {
        return (
          <>
            <div>
              <BaseButton
                v-resource={[['下载回单']]}
                disabled={!row.receiptUrl || row.receiptUrl === '-'}
                onClick={async () => {
                  // 下载回单
                  downLoadReceipt(row.receiptUrl);
                }}
                type="text"
              >
                下载回单
              </BaseButton>
              <BaseButton
                onClick={async () => {
                  // 查看明细
                  const routeData = router.resolve({
                    path: '/main/supplier/comprehensive-order/detail',
                    query: {
                      id: row.id
                    }
                  });
                  window.open(routeData.href);
                }}
                type="text"
              >
                查看明细
              </BaseButton>
            </div>
          </>
        );
      }
    })
  ],
  baseConfig: {}
});

const getListAjax = async params => {
  const [orderStartTime, orderEndTime] = params.orderTime || ['', ''];
  const [orderPayStartTime, orderPayEndTime] = params.orderPayTime || ['', ''];

  const reqData = {
    ...params,
    orderStartTime,
    orderEndTime,
    orderPayStartTime,
    orderPayEndTime
  };
  const data = await comprehensivePageList(reqData);
  return data;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      style: {"height":"760px"},
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, null, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})